/**
 * BLOC CHIFFRES CLÉS
 * Les valeurs partent de 0 et s'incrémentent quand le bloc atteint 70% de l'écran.
 *
 * Le champ ACF étant un texte libre, la saisie du back-office est analysée puis
 * restituée à l'identique : préfixe, suffixe, décimales, séparateur décimal et
 * séparateur de milliers sont conservés.
 */
jQuery(document).ready(function ($) {

    const DEPART_SCROLL = "top 70%"   // le bloc atteint 70% de la hauteur d'écran
    const DUREE = 2                   // secondes de comptage
    const STAGGER = .15               // décalage d'un chiffre au suivant

    // animations réduites : les valeurs restent affichées telles quelles
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
        return

    /**
     * Décompose une saisie : "+ 12 000 €" donne le préfixe "+ ", la cible 12000,
     * le suffixe " €" et le séparateur de milliers " ".
     *
     * Convention française : la virgule est toujours décimale. Un point suivi de
     * exactement trois chiffres est un séparateur de milliers, sinon il est décimal.
     */
    function analyse(brut) {
        if (!/\d/.test(brut))
            return null

        const debut = brut.search(/\d/)
        let fin = brut.length - 1

        while (!/\d/.test(brut[fin]))
            fin--

        const nombre = brut.slice(debut, fin + 1)
        const espace = nombre.match(/\d([\s ])(?=\d)/)

        let milliers = ""

        if (espace)
            milliers = espace[1]
        else if (/\.\d{3}(?!\d)/.test(nombre))
            milliers = "."

        let valeur = nombre.replace(/[\s ]/g, "")
        let decimales = 0
        let decimal = ","

        if (valeur.indexOf(",") > -1) {
            const parts = valeur.split(",")
            decimales = parts[1] ? parts[1].length : 0
            valeur = parts.join(".")
        } else if (milliers === ".") {
            valeur = valeur.replace(/\./g, "")
        } else if (valeur.indexOf(".") > -1) {
            // point isolé, non suivi de trois chiffres : c'est une décimale
            decimales = valeur.split(".")[1].length
            decimal = "."
        }

        const cible = parseFloat(valeur)

        if (isNaN(cible))
            return null

        return {
            prefixe: brut.slice(0, debut),
            suffixe: brut.slice(fin + 1),
            cible: cible,
            decimales: decimales,
            decimal: decimal,
            milliers: milliers
        }
    }

    /**
     * Reconstruit une valeur dans le format de la saisie d'origine
     */
    function formate(valeur, info) {
        let sortie = valeur.toFixed(info.decimales).replace(".", info.decimal)

        if (info.milliers) {
            const parts = sortie.split(info.decimal)
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, info.milliers)
            sortie = parts.join(info.decimal)
        }

        return info.prefixe + sortie + info.suffixe
    }

    $(".bloc_chiffres").each(function () {
        const bloc = this
        const chiffres = gsap.utils.toArray(bloc.querySelectorAll(".chiffres strong"))

        if (!chiffres.length)
            return

        /**
         * once: true — le comptage se joue une fois. Le rejouer à chaque passage
         * transformerait le bloc en animation permanente.
         */
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: bloc,
                start: DEPART_SCROLL,
                once: true
            }
        })

        chiffres.forEach(function (el, i) {
            const info = analyse(el.textContent.trim())

            // valeur non numérique : on n'y touche pas
            if (!info)
                return

            const etat = { valeur: 0 }

            // remise à zéro dès le chargement, déjà dans le format final
            el.textContent = formate(0, info)

            tl.to(etat, {
                valeur: info.cible,
                duration: DUREE,
                ease: "power2.out",
                onUpdate: function () {
                    el.textContent = formate(etat.valeur, info)
                }
            }, i * STAGGER)
        })
    })

})
